export const RS_CHANCE_PLUS_3 = {
  titleTable: "CHANCE+",
  descriptionTable: "DRAW [number] NUMBERS + [bonus] BONUS",
  descriptionKeyNumber: "5",
  descriptionKeyBonus: "2",
  colspan: "2",
  dataTableHeader: [
    { title: "CHANCE+ [number]", key: "3" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "3",
      bonusKey: "",
      multiplier: "3,100",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "1",
      multiplier: "80",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "2",
      multiplier: "80",
    },
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "52",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "1",
      multiplier: "2",
    },
    {
      number: "0 numbers + [bonus] bonus",
      numberKey: "0",
      bonusKey: "2",
      multiplier: "2",
    },
  ],
};

export const RS_CHANCE_PLUS_4 = {
  titleTable: "",
  descriptionTable: "",
  descriptionKeyNumber: "",
  descriptionKeyBonus: "",
  dataTableHeader: [
    { title: "CHANCE+ [number]", key: "4" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "4",
      bonusKey: "",
      multiplier: "30,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "3",
      bonusKey: "1",
      multiplier: "2,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "2",
      multiplier: "2,000",
    },
    {
      number: "[number] numbers",
      numberKey: "3",
      bonusKey: "",
      multiplier: "300",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "1",
      multiplier: "35",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "2",
      multiplier: "35",
    },
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "30",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "1",
      multiplier: "3",
    },
    {
      number: "0 numbers + [bonus] bonus",
      numberKey: "0",
      bonusKey: "2",
      multiplier: "3",
    },
  ],
};

export const RS_CHANCE_PLUS_5 = {
  titleTable: "",
  descriptionTable: "",
  descriptionKeyNumber: "",
  descriptionKeyBonus: "",
  dataTableHeader: [
    { title: "CHANCE+ [number]", key: "5" },
    { title: "MULTIPLIER", key: "" },
  ],
  dataTableContent: [
    {
      number: "[number] numbers",
      numberKey: "5",
      bonusKey: "",
      multiplier: "200,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "4",
      bonusKey: "1",
      multiplier: "20,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "3",
      bonusKey: "2",
      multiplier: "20,000",
    },
    {
      number: "[number] numbers",
      numberKey: "4",
      bonusKey: "",
      multiplier: "10,000",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "3",
      bonusKey: "1",
      multiplier: "500",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "2",
      multiplier: "500",
    },
    {
      number: "[number] numbers",
      numberKey: "3",
      bonusKey: "",
      multiplier: "200",
    },
    {
      number: "[number] numbers + [bonus] bonus",
      numberKey: "2",
      bonusKey: "1",
      multiplier: "20",
    },
    {
      number: "1 numéro + [bonus] bonus",
      numberKey: "1",
      bonusKey: "2",
      multiplier: "20",
    },
    {
      number: "[number] numbers",
      numberKey: "2",
      bonusKey: "",
      multiplier: "15",
    },
  ],
};
